class ArticlesFilter {
  constructor() {
      this.wrapper = document.getElementById('articles-wrapper');

      if(!this.wrapper) {
        return
      }

      this.form = this.wrapper.querySelector('.filter');
      this.listContainer = this.wrapper.querySelector('.articles__list');
      this.searchTimeout = null;

      this.init();
  }

  init() {
      if (!this.form || !this.listContainer) return;

      this.initRadioButtons();

      this.initSearch();

      this.initReset();

      this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.handleUpdate();
      });
  }

  initRadioButtons() {
      const groups = this.form.querySelectorAll('.js-filter-group');
      groups.forEach(group => {
          const radios = group.querySelectorAll('input[type="radio"]');
          radios.forEach(radio => {
              radio.addEventListener('change', () => {
                  this.updateActiveStates(group, radio);
                  this.handleUpdate();
              });
          });
      });
  }

  initSearch() {
      const searchInput = this.form.querySelector('input[name="s"]');
      if (searchInput) {
          searchInput.addEventListener('input', () => {
              clearTimeout(this.searchTimeout);
              this.searchTimeout = setTimeout(() => this.handleUpdate(), 300);
          });
      }
  }

  initReset() {
      const resetBtn = this.form.querySelector('.js-filter-reset');
      if (resetBtn) {
          resetBtn.addEventListener('click', (e) => {
              e.preventDefault();
              this.form.reset();
              this.form.querySelectorAll('.filter__item').forEach(item => {
                  item.classList.remove('is-active');
              });
              this.form.querySelectorAll('input[value=""]').forEach(radio => {
                  radio.closest('.filter__item').classList.add('is-active');
              });
              this.handleUpdate();
          });
      }
  }

  updateActiveStates(group, selectedRadio) {
      group.querySelectorAll('.filter__item').forEach(item => {
          item.classList.remove('is-active');
      });
      selectedRadio.closest('.filter__item').classList.add('is-active');
  }

  async handleUpdate() {
      const formData = new FormData(this.form);
      formData.append('action', 'filter');
      this.listContainer.style.opacity = '0.5';

      const xhr = new XMLHttpRequest()
      xhr.open('POST', '/app/themes/ipress/ajax/index.php', true)
      xhr.send(formData)

      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4) {
          // ok
          if (xhr.status === 200) {
            const response = JSON.parse(xhr.response)

            console.log(response.html);
            document.querySelector('.articles__list').innerHTML = response.html;

            document.querySelector('.articles__list').style.opacity = '1';
          }
          // error
          else {
            console.log('ajaxForm error!', xhr)
          }
        }
      }
  }

  updateUrl(formData) {
      const params = new URLSearchParams(formData);
      // params.delete('ajax');
      const newUrl = `${window.location.pathname}${params.toString() ? '?' + params.toString() : ''}`;
      window.history.pushState({}, '', newUrl);
  }
}

document.addEventListener('DOMContentLoaded', () => new ArticlesFilter());
